"use strict";

import {Vue} from "ui.vue";
import {Vuex} from "ui.vue.vuex";
import store from './../store/store.js'

Vue.component('bx-builder-bouquet', {
	store,
	props:{
		service: Object
	},
	created(){
		store.dispatch({type:'initialState',service: this.service})
	},
	date: () => {
		return{}
	},
	template:
	`
	<div class="builder">
		<div class="builder_wrap">
			<bx-builder-left-block/>
			<bx-builder-right-block/>
		</div>
	</div>
	`
})
